// @flow
import env from '../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  LIST_CATEGORIES: `${env.baseApiUrl}/ui/admin/store/blog/category`,
  DELETE_CATEGORY: `${env.baseApiUrl}/ui/admin/store/blog/category/:categoryId`,
  CREATE_CATEGORY: `${env.baseApiUrl}/ui/admin/store/blog/category`,
  EDIT_CATEGORY: `${env.baseApiUrl}/ui/admin/store/blog/category/:categoryId`,
});

export type BlogCategoryRequest = {
  name: string,
};

export const listCategoriesApi = getCreator(endpoints.LIST_CATEGORIES);
export const createCategoryApi = postCreator(endpoints.CREATE_CATEGORY);
export const editCategoryApi = putCreator(endpoints.EDIT_CATEGORY);
export const deleteCategoryApi = deleteCreator(endpoints.DELETE_CATEGORY);
